export default __webpack_public_path__ + "a533637e54476e0929ebe31d61d96edd.png";